import { FloatButton, Typography } from 'antd';
import { useEffect, useState } from 'react';
import GeneralHelper from '../../helpers/general';
import useIsMobile from '../../helpers/customHooks/useIsMobile';

const { Text } = Typography;

const FloorSelector = ({ floors, onChange, className, total = 0 }) => {
	const [floorOptions, setFloorOptions] = useState([]);
	const query = GeneralHelper.getParamsFromUrl();
	const [active, setActive] = useState(null);
	const [showFloorOptions, setShowFloorOptions] = useState(false);
	const [scrollTo, setScrollTo] = useState(0);

	const isMobile = useIsMobile();

	const { building_floor_id } = query || {};

	const handleSetFloorOptions = () => {
		floors.forEach((floor, i) => {
			setFloorOptions(state => ([
				...state,
				{
					value: floor._id,
					label: floor.name,
					key: floor._id
				}
			]));
		});
	};

	useEffect(() => {
		setFloorOptions([]);
		if (!floors) return;
		handleSetFloorOptions();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [floors]);

	useEffect(() => {
		setActive(building_floor_id);
		setShowFloorOptions(false);
	}, [building_floor_id]);

	// FIXME auto scroll to current floor
	useEffect(() => {
		const active_floor_button_wrap = document.querySelector('.ant-float-btn-group .ant-float-btn-group-wrap');
		const active_floor_button = document.querySelector('.ant-float-btn.active');
		let scroll_to = 0;

		if (showFloorOptions) {
			if (active_floor_button) {
				const btn_height = active_floor_button.scrollHeight;
				scroll_to = btn_height * floors.findIndex(floor => floor._id === active);
				const rect = active_floor_button.getBoundingClientRect();
				active_floor_button_wrap.scrollTo({
					behavior: 'smooth',
					top: scroll_to,
					left: 0
				});
			}
		}
	}, [showFloorOptions]);

	const renderIcon = () => {
		const current_floor = floorOptions.find(floor => floor.value === active);
		return <Text key="icon">{current_floor?.label}</Text>;
	};

	return <>
		<FloatButton.Group
			open={showFloorOptions}
			shape="square"
			trigger="click"
			type="primary"
			className="floor-selector"
			onClick={() => setShowFloorOptions(!showFloorOptions)}
			closeIcon={renderIcon()}
			icon={renderIcon()}
		// placement='left'
		>
			{floorOptions && floorOptions.map(floor => (
				<FloatButton
					onClick={() => onChange(floor.value)}
					icon={<Text>{floor.label}</Text>}
					className={floor.value === building_floor_id ? 'active' : undefined}
				/>
			))}
		</FloatButton.Group>
	</>;
};


export default FloorSelector;